import React, { memo } from 'react';
import { RefreshCwIcon, FilterIcon, DownloadIcon } from 'lucide-react';
import { ProgressBar } from '../components/ProgressBar';
export function GpuOverview() {
  // Mock data for GPU nodes
  const gpuNodes = [{
    id: 1,
    ip: '10.0.1.10',
    gpuType: 'NVIDIA A100',
    vendor: 'NVIDIA',
    utilization: 95,
    memory: {
      used: 38,
      total: 40
    },
    temp: 75,
    model: 'Llama-3-70B',
    status: 'active'
  }, {
    id: 2,
    ip: '10.0.1.11',
    gpuType: 'NVIDIA A100',
    vendor: 'NVIDIA',
    utilization: 15,
    memory: {
      used: 10,
      total: 40
    },
    temp: 55,
    model: 'Deepseek-Coder-7B',
    status: 'active'
  }, {
    id: 3,
    ip: '10.0.1.11',
    gpuType: 'NVIDIA A100',
    vendor: 'NVIDIA',
    utilization: 0,
    memory: {
      used: 0,
      total: 40
    },
    temp: 45,
    model: 'Idle',
    status: 'idle'
  }, {
    id: 4,
    ip: '10.0.1.12',
    gpuType: 'AMD MI250',
    vendor: 'AMD',
    utilization: 87,
    memory: {
      used: 110,
      total: 128
    },
    temp: 72,
    model: 'Llama-3-8B',
    status: 'active'
  }, {
    id: 5,
    ip: '10.0.1.13',
    gpuType: 'NVIDIA RTX A6000',
    vendor: 'NVIDIA',
    utilization: 65,
    memory: {
      used: 30,
      total: 48
    },
    temp: 68,
    model: 'Deepseek-33B',
    status: 'active'
  }];
  const getUtilizationColor = utilization => {
    if (utilization === 0) return 'blue';
    if (utilization < 50) return 'green';
    if (utilization < 80) return 'yellow';
    return 'red';
  };
  const getTemperatureClass = temp => {
    if (temp < 60) return 'text-green-400';
    if (temp < 75) return 'text-yellow-400';
    return 'text-red-400';
  };
  return <div className="space-y-6 text-white" data-id="element-1500">
      <div className="flex items-center justify-between" data-id="element-1501">
        <h2 className="text-xl font-bold text-white" data-id="element-1502">GPU Overview</h2>
        <div className="flex space-x-3" data-id="element-1503">
          <button className="px-3 py-1.5 border border-[#333333] rounded-md text-gray-300 hover:bg-[#1a1a1a] transition-colors text-sm flex items-center" data-id="element-1504">
            <FilterIcon size={14} className="mr-1" data-id="element-1505" />
            Filter
          </button>
          <button className="px-3 py-1.5 border border-[#333333] rounded-md text-gray-300 hover:bg-[#1a1a1a] transition-colors text-sm flex items-center" data-id="element-1506">
            <DownloadIcon size={14} className="mr-1" data-id="element-1507" />
            Export
          </button>
          <button className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm flex items-center" data-id="element-1508">
            <RefreshCwIcon size={14} className="mr-1" data-id="element-1509" />
            Refresh
          </button>
        </div>
      </div>
      <div className="bg-[#0F0F0F] rounded-lg shadow overflow-hidden border border-[#222222]" data-id="element-1510">
        <div className="overflow-x-auto" data-id="element-1511">
          <table className="min-w-full divide-y divide-[#222222]" data-id="element-1512">
            <thead className="bg-[#121212]" data-id="element-1513">
              <tr data-id="element-1514">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1515">
                  Node (IP)
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1516">
                  GPU Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1517">
                  Utilization
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1518">
                  Memory Usage
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1519">
                  Temp
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1520">
                  Model Running
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1521">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-[#0F0F0F] divide-y divide-[#222222]" data-id="element-1522">
              {gpuNodes.map(node => <tr key={node.id} className={node.status === 'idle' ? 'bg-[#0A0A0A]' : ''} data-id="element-1523">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white" data-id="element-1524">
                    {node.ip}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300" data-id="element-1525">
                    <div data-id="element-1526">{node.gpuType}</div>
                    <div className="text-xs text-gray-400" data-id="element-1527">{node.vendor}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1528">
                    <div className="flex items-center" data-id="element-1529">
                      <span className="text-sm font-medium text-white w-8" data-id="element-1530">
                        {node.utilization}%
                      </span>
                      <div className="ml-2 w-24" data-id="element-1531">
                        <ProgressBar value={node.utilization} max={100} color={getUtilizationColor(node.utilization)} size="sm" data-id="element-1532" />
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1533">
                    <div className="flex items-center" data-id="element-1534">
                      <span className="text-sm font-medium text-white w-16" data-id="element-1535">
                        {node.memory.used}/{node.memory.total} GB
                      </span>
                      <div className="ml-2 w-24" data-id="element-1536">
                        <ProgressBar value={node.memory.used} max={node.memory.total} color="blue" size="sm" data-id="element-1537" />
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1538">
                    <span className={`text-sm font-medium ${getTemperatureClass(node.temp)}`} data-id="element-1539">
                      {node.temp}°C
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300" data-id="element-1540">
                    {node.model === 'Idle' ? <span className="text-gray-500" data-id="element-1541">Idle</span> : <span className="font-medium text-white" data-id="element-1542">
                        {node.model}
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1543">
                    {node.status === 'active' ? <span className="px-2 py-1 text-xs font-medium bg-green-900 text-green-300 rounded-full" data-id="element-1544">
                        Active
                      </span> : <span className="px-2 py-1 text-xs font-medium bg-gray-800 text-gray-300 rounded-full" data-id="element-1545">
                        Idle
                      </span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1546">
        <div className="bg-[#0F0F0F] rounded-lg shadow p-4 border border-[#222222]" data-id="element-1547">
          <h3 className="text-sm font-medium text-gray-400 mb-2" data-id="element-1548">Total GPUs</h3>
          <p className="text-2xl font-semibold text-white" data-id="element-1549">5</p>
        </div>
        <div className="bg-[#0F0F0F] rounded-lg shadow p-4 border border-[#222222]" data-id="element-1550">
          <h3 className="text-sm font-medium text-gray-400 mb-2" data-id="element-1551">
            Active Models
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-1552">4</p>
        </div>
        <div className="bg-[#0F0F0F] rounded-lg shadow p-4 border border-[#222222]" data-id="element-1553">
          <h3 className="text-sm font-medium text-gray-400 mb-2" data-id="element-1554">
            Average Utilization
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-1555">52.4%</p>
        </div>
      </div>
    </div>;
}